import React from 'react';
import PropTypes from 'prop-types';

export const SideNavHeaderV3 = ({ children }) => {
  return <h2>{children}</h2>;
};

SideNavHeaderV3.propTypes = {
  children: PropTypes.node.isRequired,
};
